import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export function MainLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-text-primary">
      <Header />
      <main className="animate-fade-in-up">{children}</main>
      <Footer />
    </div>
  );
}
